import Component from "@glimmer/component";
import { action } from "@ember/object";
import { service } from "@ember/service";
import DiscourseURL from "discourse/lib/url";
import DButton from "discourse/ui-kit/d-button";
import { i18n } from "discourse-i18n";

export default class WazeAiHeaderIcon extends Component {
  @service appEvents;
  @service currentUser;
  @service siteSettings;

  get shouldShow() {
    return (
      this.siteSettings.ai_bot_enabled &&
      this.currentUser?.ai_enabled_chat_bots?.length > 0
    );
  }

  @action
  openAiConversations(event) {
    event?.preventDefault();
    this.appEvents.trigger("waze:ai-header-icon-clicked", {
      userId: this.currentUser?.id,
      source: "header_icon",
    });

    DiscourseURL.routeTo("/discourse-ai/ai-bot/conversations");
  }

  <template>
    {{#if this.shouldShow}}
      <li class="wz-header-ai-icon">
        <DButton
          class="icon btn-flat"
          @icon="w-smart-assistant"
          title={{i18n "waze.ai_header_icon.title"}}
          @action={{this.openAiConversations}}
        />
      </li>
    {{/if}}
  </template>
}
